var map = {
	"./af-ZA-Standard-A.wav": 99040,
	"./ar-XA-Standard-A.wav": 3930,
	"./ar-XA-Standard-B.wav": 84229,
	"./ar-XA-Standard-C.wav": 98124,
	"./ar-XA-Standard-D.wav": 12031,
	"./ar-XA-Wavenet-A.wav": 69699,
	"./ar-XA-Wavenet-B.wav": 98908,
	"./ar-XA-Wavenet-C.wav": 50933,
	"./ar-XA-Wavenet-D.wav": 70918,
	"./bg-BG-Standard-A.wav": 31314,
	"./bn-IN-Standard-A.wav": 76175,
	"./bn-IN-Standard-B.wav": 98888,
	"./bn-IN-Standard-C.wav": 60561,
	"./bn-IN-Standard-D.wav": 89770,
	"./bn-IN-Wavenet-A.wav": 27080,
	"./bn-IN-Wavenet-B.wav": 4367,
	"./bn-IN-Wavenet-C.wav": 37638,
	"./bn-IN-Wavenet-D.wav": 18101,
	"./ca-ES-Standard-A.wav": 976,
	"./cmn-CN-Standard-A.wav": 33141,
	"./cmn-CN-Standard-B.wav": 21546,
	"./cmn-CN-Standard-C.wav": 35555,
	"./cmn-CN-Standard-D.wav": 96040,
	"./cmn-CN-Wavenet-A.wav": 34122,
	"./cmn-CN-Wavenet-B.wav": 45717,
	"./cmn-CN-Wavenet-C.wav": 93692,
	"./cmn-CN-Wavenet-D.wav": 11023,
	"./cmn-TW-Standard-A.wav": 78553,
	"./cmn-TW-Standard-B.wav": 60046,
	"./cmn-TW-Standard-C.wav": 55927,
	"./cmn-TW-Wavenet-A.wav": 94502,
	"./cmn-TW-Wavenet-B.wav": 29265,
	"./cmn-TW-Wavenet-C.wav": 37416,
	"./cs-CZ-Standard-A.wav": 32647,
	"./cs-CZ-Wavenet-A.wav": 71664,
	"./da-DK-Neural2-D.wav": 83569,
	"./da-DK-Standard-A.wav": 38900,
	"./da-DK-Standard-C.wav": 69378,
	"./da-DK-Standard-D.wav": 20201,
	"./da-DK-Standard-E.wav": 8512,
	"./da-DK-Wavenet-A.wav": 58457,
	"./da-DK-Wavenet-C.wav": 10103,
	"./da-DK-Wavenet-D.wav": 996,
	"./da-DK-Wavenet-E.wav": 28829,
	"./de-DE-Neural2-A.wav": 67702,
	"./de-DE-Neural2-B.wav": 42529,
	"./de-DE-Neural2-C.wav": 73496,
	"./de-DE-Neural2-D.wav": 36275,
	"./de-DE-Neural2-F.wav": 54149,
	"./de-DE-Polyglot-1.wav": 77715,
	"./de-DE-Standard-A.wav": 7906,
	"./de-DE-Standard-B.wav": 87981,
	"./de-DE-Standard-D (1).wav": 46953,
	"./de-DE-Standard-D.wav": 76167,
	"./de-DE-Standard-E.wav": 53694,
	"./de-DE-Standard-F.wav": 75081,
	"./de-DE-Studio-B.wav": 84792,
	"./de-DE-Studio-C.wav": 58433,
	"./de-DE-Wavenet-A.wav": 23515,
	"./de-DE-Wavenet-B.wav": 60788,
	"./de-DE-Wavenet-C.wav": 97517,
	"./de-DE-Wavenet-D.wav": 22974,
	"./de-DE-Wavenet-E.wav": 12551,
	"./de-DE-Wavenet-F.wav": 55520,
	"./el-GR-Standard-A.wav": 34130,
	"./el-GR-Wavenet-A.wav": 1771,
	"./en-AU-Neural2-A.wav": 23385,
	"./en-AU-Neural2-B.wav": 36622,
	"./en-AU-Neural2-C.wav": 58679,
	"./en-AU-Neural2-D.wav": 65924,
	"./en-AU-News-E.wav": 99213,
	"./en-AU-News-F.wav": 53762,
	"./en-AU-News-G.wav": 8859,
	"./en-AU-Polyglot-1.wav": 74662,
	"./en-AU-Standard-A.wav": 90023,
	"./en-AU-Standard-B.wav": 25664,
	"./en-AU-Standard-C.wav": 88937,
	"./en-AU-Standard-D.wav": 3362,
	"./en-AU-Wavenet-A.wav": 13584,
	"./en-AU-Wavenet-B.wav": 10551,
	"./en-AU-Wavenet-C.wav": 14670,
	"./en-AU-Wavenet-D.wav": 46077,
	"./en-GB-Neural2-A.wav": 49540,
	"./en-GB-Neural2-B.wav": 58827,
	"./en-GB-Neural2-C.wav": 75538,
	"./en-GB-Neural2-D.wav": 84825,
	"./en-GB-Neural2-F.wav": 85495,
	"./en-GB-News-G.wav": 37816,
	"./en-GB-News-H.wav": 55323,
	"./en-GB-News-I.wav": 34402,
	"./en-GB-News-J.wav": 29325,
	"./en-GB-News-K.wav": 92596,
	"./en-GB-News-L.wav": 44359,
	"./en-GB-News-M.wav": 54782,
	"./en-GB-Standard-A.wav": 61916,
	"./en-GB-Standard-B.wav": 28259,
	"./en-GB-Standard-C.wav": 14250,
	"./en-GB-Standard-D.wav": 91985,
	"./en-GB-Standard-F.wav": 55567,
	"./en-GB-Studio-B.wav": 50234,
	"./en-GB-Studio-C.wav": 11219,
	"./en-GB-Wavenet-A.wav": 74065,
	"./en-GB-Wavenet-B.wav": 22950,
	"./en-GB-Wavenet-C.wav": 84623,
	"./en-GB-Wavenet-D.wav": 67292,
	"./en-GB-Wavenet-F.wav": 7722,
	"./en-IN-Neural2-A.wav": 67826,
	"./en-IN-Neural2-B.wav": 20637,
	"./en-IN-Neural2-C.wav": 92804,
	"./en-IN-Neural2-D.wav": 36087,
	"./en-IN-Standard-A.wav": 76214,
	"./en-IN-Standard-B.wav": 8513,
	"./en-IN-Standard-C.wav": 70104,
	"./en-IN-Standard-D.wav": 98707,
	"./en-IN-Wavenet-A.wav": 29511,
	"./en-IN-Wavenet-B.wav": 16736,
	"./en-IN-Wavenet-C.wav": 28425,
	"./en-IN-Wavenet-D.wav": 77602,
	"./en-US-Casual-K.wav": 88135,
	"./en-US-Journey-D.wav": 43215,
	"./en-US-Journey-F.wav": 27601,
	"./en-US-Neural2-A.wav": 57099,
	"./en-US-Neural2-C.wav": 91997,
	"./en-US-Neural2-D.wav": 38414,
	"./en-US-Neural2-E.wav": 7447,
	"./en-US-Neural2-F.wav": 10480,
	"./en-US-Neural2-G.wav": 32121,
	"./en-US-Neural2-H.wav": 51850,
	"./en-US-Neural2-I.wav": 65859,
	"./en-US-Neural2-J.wav": 99516,
	"./en-US-News-K.wav": 50337,
	"./en-US-News-L.wav": 30074,
	"./en-US-News-N.wav": 20268,
	"./en-US-Polyglot-1.wav": 99988,
	"./en-US-Standard-A.wav": 63933,
	"./en-US-Standard-B.wav": 11122,
	"./en-US-Standard-C.wav": 29035,
	"./en-US-Standard-D.wav": 66064,
	"./en-US-Standard-E.wav": 4057,
	"./en-US-Standard-F.wav": 93998,
	"./en-US-Standard-G.wav": 63031,
	"./en-US-Standard-H.wav": 55100,
	"./en-US-Standard-I.wav": 72949,
	"./en-US-Standard-J.wav": 7434,
	"./en-US-Studio-O.wav": 12654,
	"./en-US-Studio-Q.wav": 91500,
	"./en-US-Wavenet-A.wav": 68450,
	"./en-US-Wavenet-B.wav": 13901,
	"./en-US-Wavenet-C.wav": 72724,
	"./en-US-Wavenet-D.wav": 55111,
	"./en-US-Wavenet-E.wav": 58206,
	"./en-US-Wavenet-F.wav": 54025,
	"./en-US-Wavenet-G.wav": 90752,
	"./en-US-Wavenet-H.wav": 4019,
	"./en-US-Wavenet-I.wav": 90010,
	"./en-US-Wavenet-J.wav": 21893,
	"./es-ES-Neural2-A.wav": 29176,
	"./es-ES-Neural2-B.wav": 37631,
	"./es-ES-Neural2-D.wav": 9829,
	"./es-ES-Neural2-E.wav": 23724,
	"./es-ES-Neural2-F.wav": 1459,
	"./es-ES-Polyglot-1.wav": 60001,
	"./es-ES-Standard-A.wav": 22968,
	"./es-ES-Standard-B.wav": 47775,
	"./es-ES-Standard-C.wav": 19734,
	"./es-ES-Standard-D.wav": 3621,
	"./es-ES-Wavenet-B.wav": 97690,
	"./es-ES-Wavenet-C.wav": 35827,
	"./es-ES-Wavenet-D.wav": 21016,
	"./es-US-Neural2-A.wav": 55304,
	"./es-US-Neural2-B.wav": 90063,
	"./es-US-Neural2-C.wav": 58534,
	"./es-US-News-D.wav": 14715,
	"./es-US-News-E.wav": 5698,
	"./es-US-News-F.wav": 69421,
	"./es-US-News-G.wav": 75220,
	"./es-US-Polyglot-1.wav": 66513,
	"./es-US-Standard-A.wav": 60136,
	"./es-US-Standard-B.wav": 43311,
	"./es-US-Standard-C.wav": 74694,
	"./es-US-Studio-B.wav": 43926,
	"./es-US-Wavenet-A.wav": 56117,
	"./es-US-Wavenet-B.wav": 39626,
	"./es-US-Wavenet-C.wav": 86819,
	"./eu-ES-Standard-A.wav": 51542,
	"./fi-FI-Standard-A.wav": 95150,
	"./fi-FI-Wavenet-A.wav": 68623,
	"./fil-PH-Standard-A.wav": 86647,
	"./fil-PH-Standard-B.wav": 89680,
	"./fil-PH-Standard-C.wav": 92921,
	"./fil-PH-Standard-D.wav": 99986,
	"./fil-PH-Wavenet-A.wav": 63872,
	"./fil-PH-Wavenet-B.wav": 44583,
	"./fil-PH-Wavenet-C.wav": 47678,
	"./fil-PH-Wavenet-D.wav": 87021,
	"./fil-ph-Neural2-A.wav": 13417,
	"./fil-ph-Neural2-D.wav": 32116,
	"./fr-FR-Neural2-A.wav": 99228,
	"./fr-FR-Neural2-B.wav": 65571,
	"./fr-FR-Neural2-C.wav": 51562,
	"./fr-FR-Neural2-D.wav": 29297,
	"./fr-FR-Neural2-E.wav": 26056,
	"./fr-FR-Polyglot-1.wav": 40157,
	"./fr-FR-Standard-A.wav": 64116,
	"./fr-FR-Standard-B.wav": 3611,
	"./fr-FR-Standard-C.wav": 94594,
	"./fr-FR-Standard-D.wav": 61769,
	"./fr-FR-Standard-E.wav": 33728,
	"./fr-FR-Studio-A.wav": 65293,
	"./fr-FR-Studio-D.wav": 24352,
	"./fr-FR-Wavenet-A.wav": 4185,
	"./fr-FR-Wavenet-B.wav": 33774,
	"./fr-FR-Wavenet-C.wav": 55831,
	"./fr-FR-Wavenet-D.wav": 46724,
	"./fr-FR-Wavenet-E.wav": 90909,
	"./gu-IN-Standard-A.wav": 19023,
	"./gu-IN-Standard-B.wav": 16616,
	"./gu-IN-Wavenet-A.wav": 57800,
	"./gu-IN-Wavenet-B.wav": 60207,
	"./he-IL-Standard-A.wav": 22356,
	"./he-IL-Standard-B.wav": 61851,
	"./he-IL-Standard-C.wav": 52834,
	"./he-IL-Standard-D.wav": 3657,
	"./he-IL-Wavenet-A.wav": 39289,
	"./he-IL-Wavenet-B.wav": 52526,
	"./he-IL-Wavenet-C.wav": 90935,
	"./he-IL-Wavenet-D.wav": 81828,
	"./hi-IN-Neural2-A.wav": 42594,
	"./hi-IN-Neural2-B.wav": 37517,
	"./hi-IN-Neural2-C.wav": 788,
	"./hi-IN-Neural2-D.wav": 52551,
	"./hi-IN-Standard-A.wav": 806,
	"./hi-IN-Standard-B.wav": 51921,
	"./hi-IN-Standard-C.wav": 60072,
	"./hi-IN-Standard-D.wav": 99587,
	"./hi-IN-Wavenet-A.wav": 80503,
	"./hi-IN-Wavenet-B.wav": 83536,
	"./hi-IN-Wavenet-C.wav": 21529,
	"./hi-IN-Wavenet-D.wav": 12242,
	"./hu-HU-Standard-A.wav": 97266,
	"./hu-HU-Wavenet-A.wav": 87659,
	"./id-ID-Standard-A.wav": 29010,
	"./id-ID-Standard-B.wav": 81821,
	"./id-ID-Standard-C.wav": 37636,
	"./id-ID-Standard-D.wav": 80919,
	"./id-ID-Wavenet-A.wav": 32011,
	"./id-ID-Wavenet-B.wav": 92100,
	"./id-ID-Wavenet-C.wav": 36285,
	"./id-ID-Wavenet-D.wav": 79150,
	"./is-IS-Standard-A.wav": 94160,
	"./it-IT-Neural2-A.wav": 17318,
	"./it-IT-Neural2-C.wav": 6760,
	"./it-IT-Standard-A.wav": 52370,
	"./it-IT-Standard-B.wav": 58205,
	"./it-IT-Standard-C.wav": 26372,
	"./it-IT-Standard-D.wav": 62327,
	"./it-IT-Wavenet-A.wav": 1995,
	"./it-IT-Wavenet-B.wav": 92708,
	"./it-IT-Wavenet-C.wav": 94813,
	"./it-IT-Wavenet-D.wav": 63406,
	"./ja-JP-Neural2-B.wav": 95628,
	"./ja-JP-Neural2-C.wav": 81733,
	"./ja-JP-Neural2-D.wav": 97846,
	"./ja-JP-Standard-A.wav": 92517,
	"./ja-JP-Standard-B.wav": 69690,
	"./ja-JP-Standard-C.wav": 7827,
	"./ja-JP-Standard-D.wav": 93016,
	"./ja-JP-Wavenet-A.wav": 95002,
	"./ja-JP-Wavenet-B.wav": 26885,
	"./ja-JP-Wavenet-C.wav": 85196,
	"./ja-JP-Wavenet-D.wav": 11007,
	"./kn-IN-Standard-A.wav": 48192,
	"./kn-IN-Standard-B.wav": 615,
	"./kn-IN-Standard-C.wav": 81022,
	"./kn-IN-Standard-D.wav": 43053,
	"./kn-IN-Wavenet-A.wav": 59517,
	"./kn-IN-Wavenet-B.wav": 37330,
	"./kn-IN-Wavenet-C.wav": 20619,
	"./kn-IN-Wavenet-D.wav": 50320,
	"./ko-KR-Neural2-A.wav": 7597,
	"./ko-KR-Neural2-B.wav": 12674,
	"./ko-KR-Neural2-C.wav": 33595,
	"./ko-KR-Standard-A.wav": 73251,
	"./ko-KR-Standard-B.wav": 2460,
	"./ko-KR-Standard-C.wav": 26197,
	"./ko-KR-Standard-D.wav": 45734,
	"./ko-KR-Wavenet-A.wav": 68196,
	"./ko-KR-Wavenet-B.wav": 61131,
	"./ko-KR-Wavenet-C.wav": 43218,
	"./ko-KR-Wavenet-D.wav": 52505,
	"./lt-LT-Standard-A.wav": 44576,
	"./lv-LV-Standard-A.wav": 55344,
	"./ml-IN-Standard-A.wav": 49448,
	"./ml-IN-Standard-B.wav": 32623,
	"./ml-IN-Wavenet-A.wav": 32277,
	"./ml-IN-Wavenet-B.wav": 32138,
	"./ml-IN-Wavenet-C.wav": 79331,
	"./ml-IN-Wavenet-D.wav": 41256,
	"./mr-IN-Standard-A.wav": 55426,
	"./mr-IN-Standard-B.wav": 35501,
	"./mr-IN-Standard-C.wav": 24948,
	"./mr-IN-Wavenet-A.wav": 68379,
	"./mr-IN-Wavenet-B.wav": 5652,
	"./mr-IN-Wavenet-C.wav": 42381,
	"./ms-MY-Standard-A.wav": 43094,
	"./ms-MY-Standard-B.wav": 59041,
	"./ms-MY-Standard-C.wav": 20632,
	"./ms-MY-Standard-D.wav": 49235,
	"./ms-MY-Wavenet-A.wav": 21031,
	"./ms-MY-Wavenet-B.wav": 91904,
	"./ms-MY-Wavenet-C.wav": 19945,
	"./ms-MY-Wavenet-D.wav": 52770,
	"./nb-NO-Standard-A.wav": 75047,
	"./nb-NO-Standard-B.wav": 45920,
	"./nb-NO-Standard-C.wav": 73961,
	"./nb-NO-Standard-D.wav": 6786,
	"./nb-NO-Standard-E.wav": 32155,
	"./nb-NO-Wavenet-A.wav": 65072,
	"./nb-NO-Wavenet-B.wav": 62039,
	"./nb-NO-Wavenet-C.wav": 93006,
	"./nb-NO-Wavenet-D.wav": 46589,
	"./nb-NO-Wavenet-E.wav": 18756,
	"./nl-BE-Standard-A.wav": 74111,
	"./nl-BE-Standard-B.wav": 86040,
	"./nl-BE-Wavenet-A.wav": 68568,
	"./nl-BE-Wavenet-B.wav": 12223,
	"./nl-NL-Standard-A.wav": 51500,
	"./nl-NL-Standard-B.wav": 75315,
	"./nl-NL-Standard-C.wav": 61306,
	"./nl-NL-Standard-D.wav": 81569,
	"./nl-NL-Standard-E.wav": 12536,
	"./nl-NL-Wavenet-A.wav": 19265,
	"./nl-NL-Wavenet-B.wav": 95414,
	"./nl-NL-Wavenet-C.wav": 72927,
	"./nl-NL-Wavenet-D.wav": 47116,
	"./nl-NL-Wavenet-E.wav": 45125,
	"./pa-IN-Standard-A.wav": 23046,
	"./pa-IN-Standard-B.wav": 57809,
	"./pa-IN-Standard-C.wav": 12488,
	"./pa-IN-Standard-D.wav": 34211,
	"./pa-IN-Wavenet-A.wav": 30839,
	"./pa-IN-Wavenet-B.wav": 33872,
	"./pa-IN-Wavenet-C.wav": 13817,
	"./pa-IN-Wavenet-D.wav": 20882,
	"./pl-PL-Standard-A.wav": 92408,
	"./pl-PL-Standard-B.wav": 36063,
	"./pl-PL-Standard-C.wav": 58550,
	"./pl-PL-Standard-D.wav": 91909,
	"./pl-PL-Standard-E.wav": 10252,
	"./pl-PL-Wavenet-A.wav": 97029,
	"./pl-PL-Wavenet-B.wav": 16730,
	"./pl-PL-Wavenet-C.wav": 5011,
	"./pl-PL-Wavenet-D.wav": 16376,
	"./pl-PL-Wavenet-E.wav": 63841,
	"./pt-BR-Neural2-A.wav": 10424,
	"./pt-BR-Neural2-B.wav": 98495,
	"./pt-BR-Neural2-C.wav": 32886,
	"./pt-BR-Standard-B.wav": 39679,
	"./pt-BR-Standard-C.wav": 57718,
	"./pt-BR-Wavenet-A.wav": 66437,
	"./pt-BR-Wavenet-B.wav": 34554,
	"./pt-BR-Wavenet-C.wav": 48563,
	"./pt-PT-Standard-B.wav": 38287,
	"./pt-PT-Standard-C.wav": 71558,
	"./pt-PT-Standard-D.wav": 52021,
	"./pt-PT-Wavenet-A.wav": 14773,
	"./pt-PT-Wavenet-B.wav": 3178,
	"./pt-PT-Wavenet-C.wav": 17187,
	"./pt-PT-Wavenet-D.wav": 77672,
	"./ro-RO-Standard-A.wav": 87234,
	"./ro-RO-Wavenet-A.wav": 28091,
	"./ru-RU-Standard-A.wav": 33646,
	"./ru-RU-Standard-B.wav": 20409,
	"./ru-RU-Standard-C.wav": 32560,
	"./ru-RU-Standard-D.wav": 86507,
	"./ru-RU-Standard-E.wav": 88741,
	"./ru-RU-Wavenet-A.wav": 7759,
	"./ru-RU-Wavenet-C.wav": 75793,
	"./ru-RU-Wavenet-D.wav": 21354,
	"./ru-RU-Wavenet-E.wav": 52195,
	"./sk-SK-Standard-A.wav": 85352,
	"./sk-SK-Wavenet-A.wav": 54325,
	"./sr-RS-Standard-A.wav": 66924,
	"./sv-SE-Standard-A.wav": 93579,
	"./sv-SE-Standard-B.wav": 84292,
	"./sv-SE-Standard-C.wav": 32477,
	"./sv-SE-Standard-D.wav": 81838,
	"./sv-SE-Standard-E.wav": 20247,
	"./sv-SE-Wavenet-A.wav": 61980,
	"./sv-SE-Wavenet-B.wav": 32771,
	"./sv-SE-Wavenet-C.wav": 2410,
	"./sv-SE-Wavenet-D.wav": 68753,
	"./sv-SE-Wavenet-E.wav": 76904,
	"./ta-IN-Standard-A.wav": 87706,
	"./ta-IN-Standard-C.wav": 12076,
	"./ta-IN-Standard-D.wav": 8159,
	"./ta-IN-Wavenet-A.wav": 11747,
	"./ta-IN-Wavenet-B.wav": 57308,
	"./ta-IN-Wavenet-C.wav": 81045,
	"./ta-IN-Wavenet-D.wav": 84230,
	"./te-IN-Standard-A.wav": 68286,
	"./te-IN-Standard-B.wav": 64105,
	"./th-TH-Neural2-C.wav": 61014,
	"./th-TH-Standard-A.wav": 92856,
	"./tr-TR-Standard-A.wav": 34872,
	"./tr-TR-Standard-B.wav": 6591,
	"./tr-TR-Standard-C.wav": 40982,
	"./tr-TR-Standard-D.wav": 41701,
	"./tr-TR-Standard-E.wav": 26860,
	"./tr-TR-Wavenet-A.wav": 34821,
	"./tr-TR-Wavenet-B.wav": 2938,
	"./tr-TR-Wavenet-C.wav": 16947,
	"./tr-TR-Wavenet-D.wav": 54168,
	"./tr-TR-Wavenet-E.wav": 23201,
	"./uk-UA-Standard-A.wav": 21750,
	"./uk-UA-Wavenet-A.wav": 84711,
	"./vi-VN-Neural2-A.wav": 89477,
	"./vi-VN-Neural2-D.wav": 8824,
	"./vi-VN-Standard-A.wav": 35931,
	"./vi-VN-Standard-B.wav": 96436,
	"./vi-VN-Standard-C.wav": 6989,
	"./vi-VN-Standard-D.wav": 56350,
	"./vi-VN-Wavenet-A.wav": 38156,
	"./vi-VN-Wavenet-B.wav": 15891,
	"./vi-VN-Wavenet-C.wav": 43962,
	"./vi-VN-Wavenet-D.wav": 91073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88285;